import { SystemStyleObject } from '@chakra-ui/react';
import {
  ColorMode,
  getBoxSizingStyles,
} from '@allergan-data-labs/alle-elements-core';

export const getActionFooterStyles = (
  colorMode: ColorMode
): SystemStyleObject => {
  return {
    ...getBoxSizingStyles(),
    position: 'sticky',
    bottom: '0',
    background: `${colorMode}.Container/Neutral/Base`,
    /**
      The following block of code ensures that the list still has the appropriate
      padding but that the footer actually sits outside of the padding boundaries
      to ensure that you do not see any focus ring behind or underneath the
      action menu footer component. Also, placing the footer outside of the
      action menu content component was not an option since the Chakra component
      did not hide the footer element when the menu is closed.
    */
    p: '8',
    width: 'calc(100% + 16px)',
    marginLeft: '-8px',
    marginTop: '4',
  };
};
